import React from "react";
import { Link, useLocation } from "react-router-dom";
import { breadcrumbs } from "../../core/data/interface/interface";
import { all_routes } from "../router/all_routes";

const Breadcrumbs = (props: breadcrumbs) => {
  const routes = all_routes;
  const location = useLocation();
  const normalizedPath = location.pathname.replace(/\/+$/, "") || "/";
  const isBlogRoute = normalizedPath === routes.bloglist || normalizedPath.startsWith(`${routes.bloglist}/`);
  let addButton = null;
  if (
    normalizedPath === routes.listinggrid ||
    normalizedPath === routes.listinglist ||
    normalizedPath === routes.bookingcheckout ||
    normalizedPath === routes.booking ||
    normalizedPath === routes.invoice ||
    normalizedPath === routes.listingdetails ||
    normalizedPath === routes.ourteam ||
    normalizedPath === routes.testimonial ||
    normalizedPath === routes.termsconditions ||
    normalizedPath === routes.privacypolicy ||
    normalizedPath === routes.about ||
    normalizedPath === routes.pricing ||
    normalizedPath === routes.faq ||
    normalizedPath === routes.gallery ||
    isBlogRoute ||
    
    normalizedPath === routes.contact
  ) {
    addButton = (
      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title">{props.title}</h2>
              <nav aria-label="breadcrumb" className="page-breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={routes.home}>Home</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    {props.title}
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>
    );
  } 


  else if( normalizedPath === routes.dashboard ||
    normalizedPath === routes.messages ||
    normalizedPath === routes.payment ||
    normalizedPath === routes.reviews ||
    normalizedPath === routes.userbookings ||
    normalizedPath === routes.userBookingUpcoming ||
    normalizedPath === routes.userBookingCancelled ||
    normalizedPath === routes.userBookingInprogress ||
    normalizedPath === routes.userBookingComplete ||
    normalizedPath === routes.wallet ||
    normalizedPath === routes.integration){
    addButton = (
      <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title">{props.title}</h2>
            <nav aria-label="breadcrumb" className="page-breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to={routes.home}>Home</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                 {props.subtitle}
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
    </div>
    )
  }
  
  
  
  else {
    addButton = (
      <div className="row align-items-center">
        <div className="col">
          <h3 className="page-title">{props.maintitle}</h3>
          <ul className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/admin-dashboard">{props.title}</Link>
            </li>
            <li className="breadcrumb-item active">{props.subtitle}</li>
          </ul>
        </div>
        <div className="col-auto float-end ms-auto"></div>
      </div>
    );
  }
  return (
    <>
      {addButton}
    </>
  );
};

export default Breadcrumbs;
